import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import { Send, Loader2 } from 'lucide-react';

export const ShareReportDialog = ({
  open, onOpenChange, selectedYear, sharing,
  shareEmail, setShareEmail, shareName, setShareName,
  shareMessage, setShareMessage, shareIncludeZip, setShareIncludeZip, onShare,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-800 border-slate-700">
      <DialogHeader>
        <DialogTitle className="text-white flex items-center gap-2">
          <Send className="h-5 w-5 text-purple-400" />
          Share Report with Accountant
        </DialogTitle>
        <DialogDescription className="text-slate-400">
          Email your {selectedYear} tax report directly to your accountant via Seafarer Logbook.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label className="text-slate-300">Accountant's Email *</Label>
          <Input
            type="email"
            value={shareEmail}
            onChange={(e) => setShareEmail(e.target.value)}
            placeholder="accountant@example.com"
            className="bg-slate-900 border-slate-600 text-white"
            data-testid="share-email-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-300">Recipient Name (optional)</Label>
          <Input
            type="text"
            value={shareName}
            onChange={(e) => setShareName(e.target.value)}
            placeholder="e.g. John Smith"
            className="bg-slate-900 border-slate-600 text-white"
            data-testid="share-name-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-300">Personal Message (optional)</Label>
          <Textarea
            value={shareMessage}
            onChange={(e) => setShareMessage(e.target.value)}
            placeholder="Hi, please find my SED tax report attached..."
            className="bg-slate-900 border-slate-600 text-white resize-none"
            rows={3}
            data-testid="share-message-input"
          />
        </div>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="includeZip"
            checked={shareIncludeZip}
            onChange={(e) => setShareIncludeZip(e.target.checked)}
            className="rounded border-slate-600 bg-slate-900 text-amber-500 focus:ring-amber-500"
            data-testid="share-include-zip"
          />
          <Label htmlFor="includeZip" className="text-slate-300 text-sm cursor-pointer">
            Also attach full ZIP package (includes CSVs and supporting documents)
          </Label>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-600 text-slate-300">
          Cancel
        </Button>
        <Button onClick={onShare} disabled={sharing || !shareEmail} className="bg-purple-600 hover:bg-purple-700" data-testid="share-send-btn">
          {sharing ? (
            <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Sending...</>
          ) : (
            <><Send className="mr-2 h-4 w-4" />Send Report</>
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
